module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SliderText"
  }, [(_vm.content.supertitle || _vm.content.title || _vm.content.smalltitle || _vm.content.subtitle || _vm.content.subtitle2) ? _c('div', {
    staticClass: "SliderText-header"
  }, [(_vm.content.superTitle) ? _c('p', {
    staticClass: "SliderText-supertitle t-caps",
    domProps: {
      "innerHTML": _vm._s(_vm.content.superTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.title) ? _c('p', {
    staticClass: "SliderText-title t-headingMd",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.smalltitle) ? _c('p', {
    staticClass: "SliderText-smalltitle t-headingSm",
    domProps: {
      "innerHTML": _vm._s(_vm.content.smalltitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.subtitle) ? _c('p', {
    staticClass: "SliderText-subtitle t-caps",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.subtitle2) ? _c('p', {
    staticClass: "SliderText-subtitle SliderText-subtitle2 t-caps",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subtitle2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.subtitle3) ? _c('p', {
    staticClass: "SliderText-subtitle SliderText-subtitle3 t-caps",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subtitle3)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.content.text) ? _c('div', {
    staticClass: "SliderText-content"
  }, [(_vm.content.text) ? _c('pre', {
    staticClass: "t-headingSm",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }, [_vm._v("    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.content.list) ? _c('ol', {
    staticClass: "SliderText-list t-list"
  }, _vm._l((_vm.content.list), function(item) {
    return _c('li', {
      staticClass: "t-listItem"
    }, [(item.supertitle) ? _c('p', {
      staticClass: "t-caps",
      domProps: {
        "innerHTML": _vm._s(item.supertitle)
      }
    }) : _vm._e(), _vm._v(" "), (item.title) ? _c('p', {
      staticClass: "SliderText-listItemTitle t-headingSm",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.content.footer) ? _c('p', {
    staticClass: "SliderText-footer t-small",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footer)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e73f71e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/Text.vue
// module id = 386
// module chunks = 1